import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowRightDown16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M13.25 12.1894V5.99997H14.75L14.75 14.75L5.99999 14.75V13.25H12.1893L1.4696 2.5303L2.53026 1.46964L13.25 12.1894Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowRightDown16.displayName = 'ArrowRightDown16';
export default ArrowRightDown16;
